import { useState, useEffect, useRef } from "react";
import { useExam } from "../context/ExamContext";
import { KEYS } from "../constants/storageKeys";

export const useCountdown = () => {
  const { timeLeft: initialSeconds = 0, updateStageTimeLeft } = useExam();
  const [timeLeft, setTimeLeft] = useState(initialSeconds);
  const endTimeRef = useRef();
  const intervalRef = useRef();

  useEffect(() => {
    if (initialSeconds <= 0) {
      setTimeLeft(0);
      return;
    }

    endTimeRef.current = Date.now() + initialSeconds * 1000;
    setTimeLeft(initialSeconds);

    const tick = () => {
      const remaining = Math.max(
        0,
        Math.round((endTimeRef.current - Date.now()) / 1000)
      );
      sessionStorage.setItem(KEYS.DURATION, remaining)

      setTimeLeft(remaining);

      if (remaining === 0) {
        clearInterval(intervalRef.current);
        if (updateStageTimeLeft) updateStageTimeLeft(0);
      }
    };

    tick(); // run immediately
    intervalRef.current = setInterval(tick, 1000);

    return () => clearInterval(intervalRef.current);
  }, [initialSeconds]);

  return timeLeft;
};
